import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  FormControl,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import FileUploader from "../../Components/UI/FileUploader";
import Select from "react-select";
import { Back, Folder, House } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import {
  getAdvertiser,
  getS3FilesAndFoldersAction,
  validateFolderNameAction,
  uploadToDSP,
  uploadToS3,
} from "../../Redux/Actions/OPCreativeUploadActions";
import Spinner from "../../Components/UI/Spinner/Spinner";
import * as yup from "yup";
import axios from "../../axiosConfig";
import moment from "moment";
import CsvDownloader from "react-csv-downloader";
import { isIPv6 } from "net";

function ModalImageShow(props: any) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <img
          src={props.imgShowURL}
          alt={props.imgShowURL ? "S3 Image" : "Image Not Found"}
          className="img-fluid"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const OPCreativeUpload = () => {
    const opCreativeUploadState = useSelector(
    (state: IReduxState) => state.OPCreativeUpload
  );
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const dispatch = useDispatch();
  const [currentScreen, setCurrentScreen] = useState("existingFolder");
  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState<any>([]);
  const [advertiserOptions, setAdvertiserOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [S3UploaderPopUp, setS3UploaderPopUp] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  // const [dspNames, setDspNames] = useState([])
  const [currentSelected, setCurrentSelected] = useState<any>([]); //Selected Files Object To Upload
  const [currentSelectedID, setCurrentSelectedID] = useState<any>([]); //Selected Files ID To maintain checkbox selection
  const [selectAll, setSelectAll] = useState(false); // USED FOR SELECT ALL FILES OPTION.
  const [createSubFolderPopup, setCreateSubFolderPopup] = useState(false);
  const [checkFolder, setCheckFolder] = useState(false);
  const [validFolder, setValidFolder] = useState(false);
  const [imgShow, setImgShow] = useState(false);
  const [imgShowURL, setImgShowURL] = useState("");
  const [csvData, setCsvData] = useState<any[]>([]);
  const [noasSelection, setNoasSelection] = useState(AuthState.cc_infinite_fifo? "no" : "yes");
  const [noasDisabled, setNoasDisabled] = useState(AuthState.cc_infinite_fifo? true : false);



  const dspOptions = [{ value: "beeswax", label: "Beeswax" }];
  /*const envOptions = [
    { value: "app", label: "InApp" },
    { value: "web", label: "Web" },
  ];*/
  const OsOptions = [
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
    { value: "all_oss", label: "All_OSs" },
  ];
  //const tagOptions = [{ value: "regular", label: "Regular" }];
  const yesnoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#5369f8" : "white",
      color: state.isFocused ? "white" : "#4b4b5a",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#4b4b5a",
    }),
    control: (provided: any) => ({
      ...provided,
      // border: 'none',
      boxShadow: "none",
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: "none",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "gray",
    }),
  };

  const dspFormik = useFormik({
    initialValues: {
      dsp: "",
      adv: 0,
      env: "",
      os: "",
      landingPage: "",
      CreativeName: "",
      creatives: [],
      noas: "yes",
      cookie: "yes",
      useragent: "no",
      timer: "no",
      suffix: "",
      infinite_fifo: AuthState?.cc_infinite_fifo ? "yes" : "no",
      infinite_fifo_id: "",
      ipV6:"no"
    },
    validationSchema:  yup.object().shape({
            infinite_fifo_id: yup.string()
                      .when("infinite_fifo", {
                        is: "yes",
                        then: yup.string().required("*"),
                      }),
    }),
    onSubmit: (value, { resetForm }) => {
      //console.log(value);
    },
  });

  const createSubFolderForm = useFormik({
    initialValues: {
      folder_name: "",
    },
    validationSchema: yup.object().shape({
      folder_name: yup.string().required("*"),
    }),
    onSubmit: (values, { resetForm }) => {
      //console.log(values);
    },
  });

  useEffect(() => {
    dispatch(getAdvertiser());
    // dispatch(getS3FilesAndFoldersAction());
  }, [dispatch]);

  useEffect(() => {
    setAdvertiserOptions([
      ...opCreativeUploadState.adv.map((adv: any) => ({
        value: adv.advId,
        label: adv.advName,
      })),
    ]);
  }, [opCreativeUploadState.adv]);

  useEffect(() => {
    // console.log(creativeUploadState);
  }, [opCreativeUploadState]);

  const handleCheckFolderContent = () => {
    let pathCheck: any = [];
    if (opCreativeUploadState.curFolder) {
      pathCheck = opCreativeUploadState.curFolder.split("/");
    }

    dispatch(
      getS3FilesAndFoldersAction(
        opCreativeUploadState.curFolder && currentSelectedID.length > 0
          ? opCreativeUploadState.curFolder
          : folderName
          ? pathCheck && pathCheck.length > 0 && pathCheck[0] !== folderName
            ? pathCheck[0]
            : folderName
          : ""
      )
    );
    // setShowValidationModal(true);
  };
  const handleFolderClick = (folderNames: any) => {
    dispatch(getS3FilesAndFoldersAction(folderNames));
    // setShowValidationModal(true);
  };
  const handleValidateName = () => {
    dispatch(validateFolderNameAction(folderName));
    setShowValidationModal(true);
  };
  const handleClose = () => {
    setShowValidationModal(false);
  };

  const handleFolderBack = (folderNames: String) => {
    //console.log(folderNames);
    var subs = folderNames.split("/");
    //console.log(subs.length);
    if (subs.length > 2) {
      dispatch(
        getS3FilesAndFoldersAction(
          folderNames.substring(0, folderNames.indexOf(subs[subs.length - 2]))
        )
      );
    } else {
      dispatch(
        getS3FilesAndFoldersAction(
          folderName ? (subs[0] !== folderName ? subs[0] : folderName) : ""
        )
      );
    }
  };

  const handleUploadAllFiles = (e: any) => {
    let s3FilesArr = opCreativeUploadState.s3Files;

    let selectedArr = [...currentSelected];
    let selectedIDArr = [...currentSelectedID];

    s3FilesArr.forEach((file: any) => {
      var imageUrl =
        "https://cloud-images.s3.eu-west-1.amazonaws.com/" +
        opCreativeUploadState.curFolder +
        file.name;
      imageUrl = imageUrl.replaceAll(" ", "%20");
      const fname = opCreativeUploadState.curFolder + file.name;
      var obj = { fname: "", width: 0, height: 0, url: imageUrl };
      obj.fname = fname;
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        obj.height = img.height;
        obj.width = img.width;
      };

      if (e.target.checked) {
        if (!selectedIDArr.includes(file.id)) {
          selectedArr.push(obj);
          selectedIDArr.push(file.id);
        }
      } else {
        const index = selectedArr.findIndex((x) => x.fname === fname);
        selectedArr.splice(index, 1);

        const indexID = selectedIDArr.indexOf(file.id);
        selectedIDArr.splice(indexID, 1);
      }
    });
    setCurrentSelected(selectedArr);
    setCurrentSelectedID(selectedIDArr);
    setSelectAll(e.target.checked);
  };

  const addToSelectedFiles = (file: any, e: any) => {
    var imageUrl =
      "https://cloud-images.s3.eu-west-1.amazonaws.com/" +
      opCreativeUploadState.curFolder +
      file.name;
    imageUrl = imageUrl.replaceAll(" ", "%20");
    const fname = opCreativeUploadState.curFolder + file.name;
    var obj = { fname: "", width: 0, height: 0, url: imageUrl };
    obj.fname = fname;
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      obj.height = img.height;
      obj.width = img.width;
    };
    let selectedArr = [...currentSelected];
    let selectedIDArr = [...currentSelectedID];
    if (e.target.checked) {
      selectedArr.push(obj);
      selectedIDArr.push(file.id);

      let s3FilesArr = opCreativeUploadState.s3Files;
      if (selectedIDArr.length === s3FilesArr.length) {
        setSelectAll(true);
      }
    } else {
      const index = selectedArr.findIndex((x) => x.fname === fname);
      selectedArr.splice(index, 1);

      const indexID = selectedIDArr.indexOf(file.id);
      selectedIDArr.splice(indexID, 1);
      if (selectAll) {
        setSelectAll(false);
      }
    }
    setCurrentSelected(selectedArr);
    setCurrentSelectedID(selectedIDArr);
  };

  const calcCurrentFolder = () => {
    if (opCreativeUploadState.curFolder !== "") {
      var arr = opCreativeUploadState.curFolder.split("/");
      return arr[arr.length - 2];
    } else {
      return "";
    }
  };

  const submitToDSP = () => {
    var currentFolder = calcCurrentFolder();
    dispatch(
      uploadToDSP(
        selectedFileNames,
        dspFormik.values.dsp,
        dspFormik.values.adv,
        //dspFormik.values.env,
        dspFormik.values.os,
        dspFormik.values.landingPage,
        currentFolder,
        dspFormik.values.CreativeName,
        dspFormik.values.noas,
        dspFormik.values.cookie,
        dspFormik.values.useragent,
        dspFormik.values.timer,
        dspFormik.values.suffix,
        dspFormik.values.infinite_fifo,
        dspFormik.values.infinite_fifo_id,
        dspFormik.values.ipV6
      )
    );
  };

  const handleUploadToS3 = () => {
    var folder = opCreativeUploadState.curFolder;
    var ff = new FormData();
    ff.append("folder", "" + folder);
    filesToUpload.forEach((element: any) => {
      ff.append("data", element);
    });
    dispatch(uploadToS3(ff, folder));
    setSelectedFileNames([]);
  };

  const changeDsp = (option: any) => {
    dspFormik.setFieldValue("dsp", option.value);
  };
  const changeAdv = (option: any) => {
    dspFormik.setFieldValue("adv", option.value);
  };
  /*const changeEnv = (option: any) => {
    dspFormik.setFieldValue("env", option.value);
  };*/
  const changeOs = (option: any) => {
    dspFormik.setFieldValue("os", option.value);
  };
  const changeNOAS = (option: any) => {
    dspFormik.setFieldValue("noas", option.value);
    setNoasSelection(option.value);
  };
  const changeCookie = (option: any) => {
    dspFormik.setFieldValue("cookie", option.value);
  };
  const changeIpV6 = (option: any) => {
    dspFormik.setFieldValue("ipV6", option.value);
  };

  const changeUseragent = (option: any) => {
    dspFormik.setFieldValue("useragent", option.value);
  };
  const changeTimer = (option: any) => {
    dspFormik.setFieldValue("timer", option.value);
  };
  const changeInfiniteFifo = (option: any) => {
    dspFormik.setFieldValue("infinite_fifo", option.value);
    if (option.value === "yes") {
      dspFormik.setFieldValue("noas", "no");
      setNoasSelection("no");
      setNoasDisabled(true);
  } else {
    dspFormik.setFieldValue("infinite_fifo_id", "");
    setNoasDisabled(false);
  }
}
  // const changeUA = (option: any) => {
  //   dspFormik.setFieldValue("otf", option.value);
  // };
  // const changeDomain = (option: any) => {
  //   dspFormik.setFieldValue("domain", option.value);
  // };

  /*const changeTag = (option: any) => {
    dspFormik.setFieldValue("tagType", option.value);
  };*/

  async function handleCreateSubFolder(): Promise<any> {
    try {
      const response = await axios.get(
        `validateName?folderName=${opCreativeUploadState.curFolder}${folderName}`
      );

      const { status } = response;
      if (status === 200) {
        dispatch(
          getS3FilesAndFoldersAction(
            `${opCreativeUploadState.curFolder}${folderName}/`
          )
        );
        setValidFolder(true);
        setCheckFolder(true);
        setCreateSubFolderPopup(false);
      }
    } catch (error: any) {
      setCheckFolder(true);
      setValidFolder(false);
    }
  }
  useEffect(() => {
    console.log(selectedFileNames)
    setCsvData(selectedFileNames.map((obj: any) => [obj.url]));
  }, [selectedFileNames]);

  return (
    <>
      {["CreateFolder", "existingFolder", "DSPsubmit"].includes(
        currentScreen
      ) && (
        <Row className="d-flex justify-content-center mt-3">
          <Row>
            <h3 className="module_title">OP Creative Upload</h3>
          </Row>
        </Row>
      )}

      <Col className="transperent" style={{ padding: "12px" }}>
        {(currentScreen === "CreateFolder" ||
          currentScreen === "existingFolder") && (
          <>
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  {/* <Row>
                      <div className="menu_tabs">
                        <Tab.Container defaultActiveKey="existingFolder">
                          <Nav
                            style={{ width: "100%" }}
                            as="ul"
                            justify
                            variant="pills"
                            className="p-1"
                          >
                            <Nav.Item as="li" key={"existingFolder"}>
                              <Nav.Link
                                onClick={() => {
                                  setCurrentScreen("existingFolder");
                                }}
                                className="cursor-pointer"
                                eventKey={"existingFolder"}
                              >
                                <span className="d-none d-sm-block">
                                  Use existing folder
                                </span>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" key={"CreateFolder"}>
                              <Nav.Link
                                onClick={() => {
                                  setCurrentScreen("CreateFolder");
                                }}
                                className="cursor-pointer"
                                eventKey={"CreateFolder"}
                              >
                                <span className="d-none d-sm-block">
                                  Create new folder
                                </span>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </Tab.Container>
                      </div>
                    </Row> */}
                  <Row>
                    <Col lg={12} className="mb-2">
                      {currentScreen === "CreateFolder" && (
                        <Button
                          className="order-12 s3fileuploadexp"
                          style={{ margin: "0", width: "150px" }}
                          //variant="primary"
                          onClick={() => {
                            handleValidateName();
                          }}
                        >
                          Validate Name
                        </Button>
                      )}
                      {currentScreen === "existingFolder" && (
                        <Button
                          onClick={() => {
                            handleCheckFolderContent();
                            setCurrentScreen("S3Browser");
                          }}
                          className="order-12 s3fileuploadexp"
                          style={{ margin: "0", width: "150px" }}
                          //variant="primary"
                        >
                          Select files on S3
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      lg={3}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      {currentScreen === "CreateFolder" && (
                        <span>Folder Name</span>
                      )}
                      {currentScreen === "existingFolder" && (
                        <span>S3 Folder Path</span>
                      )}
                    </Form.Label>
                    <Col
                      lg={9}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Form.Control
                        name="folderName"
                        type="text"
                        id="simpleinput"
                        value={folderName}
                        onChange={(e) => {
                          setFolderName(e.target.value);
                        }}
                        className="fsz-875rem"
                      />
                    </Col>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Row>
            {currentScreen === "CreateFolder" && (
              <>
                {!showValidationModal && opCreativeUploadState.loading && (
                  <div className="popUpUser">
                    <Spinner className="m-2" color={"primary"}></Spinner>
                  </div>
                )}
                <Row style={{ marginBottom: "24px" }}>
                  <Col lg={6} style={{ paddingLeft: "0" }}>
                    <Card>
                      <Card.Body>
                        <FileUploader
                          onFileUpload={(files) => {
                            const namesArr: any = files.map((file) => {
                              const { path, dimensions } = file;
                              return `${path} ${dimensions}`;
                            });
                            setSelectedFileNames(namesArr);
                            setFilesToUpload(files);
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} style={{ paddingRight: "0" }}>
                    <Card style={{ height: "100%" }}>
                      <Card.Body>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          UPLOADED FILE NAMES
                        </h4>
                        {selectedFileNames.map((filename: any) => (
                          <p>{filename}</p>
                        ))}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
            {currentScreen === "existingFolder" && (
              <Row style={{ marginBottom: "24px" }}>
                <Col style={{ padding: "0" }}>
                  <Card>
                    <Card.Body>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          selected files from s3
                        </h4>
                        <CsvDownloader
                        datas={csvData}
                        text="Export S3 URLs"
                        filename={`s3_urls_` + new Date().toLocaleString()}
                        extension=".csv"
                        className="btn btn-primary ExportBtn no-margin"
                        />
                      </div>
                      <Row style={{ marginBottom: "10px" }}>
                        <Table
                          responsive
                          className="table-nowrap table-centered mb-0"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "50%" }}>S3 FileName</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedFileNames.map(
                              (filename: any, index: any) => (
                                <tr key={index}>
                                  <td style={{ width: "50%" }}>
                                    {filename.fname}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  {currentScreen === "CreateFolder" && (
                    <>
                      <Button
                        id="special-diabled-button"
                        style={{ marginBottom: "0" }}
                        variant="primary"
                        onClick={() => {
                          handleUploadToS3();
                        }}
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Upload to S3
                      </Button>
                      <Button
                        variant="secondary"
                        style={{ marginBottom: "0" }}
                        onClick={() => {
                          setCurrentScreen("DSPsubmit");
                        }}
                        id="special-diabled-button"
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Continue
                      </Button>
                    </>
                  )}
                  {currentScreen === "existingFolder" && (
                    <Button
                      onClick={() => {
                        setCurrentScreen("DSPsubmit");
                      }}
                      style={{ margin: "0" }}
                      variant="primary"
                      disabled={
                        selectedFileNames && selectedFileNames.length > 0
                          ? false
                          : true
                      }
                    >
                      Continue
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Row>
          </>
        )}
        {currentScreen === "S3Browser" && (
          <>
            {opCreativeUploadState.loading && (
              <div className="popUpUser">
                <Spinner className="m-2" color={"primary"}></Spinner>
              </div>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  color: "#343a40",
                  textAlign: "left",
                  fontSize: "1.05rem",
                  fontWeight: "600",
                }}
              >
                Folder Name:<p>{opCreativeUploadState.curFolder} </p>
              </h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <ButtonGroup
                  className=" fsz-875rem"
                  style={{
                    width: "max-content",
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{ margin: "0" }}
                    variant="light"
                    onClick={() => {
                      handleFolderBack(opCreativeUploadState.curFolder);
                    }}
                  >
                    <Back /> <span>Back</span>
                  </Button>
                </ButtonGroup>

                <Button
                  className="fsz-875rem"
                  variant="light"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "max-content",
                    margin: "0 0 0 8px",
                  }}
                  onClick={() => {
                    handleCheckFolderContent();
                  }}
                >
                  <House className="me-2 fsz-875rem" />
                  <span>Home</span>
                </Button>
              </div>
            </div>

            <h6 style={{ fontSize: "18px", fontWeight: "600" }}>Sub-Folders</h6>
            <Row>
              <Col xxl={3} lg={6}>
                <Button
                  onClick={() => {
                    setCreateSubFolderPopup(true);
                  }}
                  variant="info"
                >
                  + Create New Sub-Folder
                </Button>
              </Col>
            </Row>
            <Row>
              {(opCreativeUploadState.s3Folders || []).map(
                (f: any, i: number) => {
                  let folderDetails = f.name.split("/");

                  return (
                    <Col key={i} xxl={3} lg={6}>
                      <Card
                        className="shadow-none border"
                        style={{ marginBottom: "24px" }}
                      >
                        <div style={{ padding: "12px" }}>
                          <Row className="align-items-center">
                            <Col
                              className="col-auto"
                              style={{ marginLeft: "15px" }}
                            >
                              <div className="avatar-sm">
                                <span
                                  className={`avatar-title rounded fs-24 bg-soft-info text-info`}
                                  style={{ padding: "8px" }}
                                >
                                  <Folder size={24} color="#35c2e3" />
                                </span>
                              </div>
                            </Col>
                            <Col className="ps-1">
                              <Link
                                to="#"
                                style={{ textDecoration: "none" }}
                                className="text-muted fw-bold fs-15"
                              >
                                <span
                                  onClick={() => {
                                    handleFolderClick(f.name);
                                  }}
                                >
                                  {folderDetails[folderDetails.length - 2]}
                                  <br />
                                  <span
                                    style={{ fontWeight: 400, opacity: "0.7" }}
                                  >
                                    Last Modified:{" "}
                                    {moment(f.lastMod).format("DD/MM/YYYY")}
                                  </span>
                                </span>
                              </Link>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </Col>
                  );
                }
              )}
            </Row>
            <Row>
              <Col xs={12}>
                <h6 style={{ fontSize: "18px", fontWeight: "600" }}>Files</h6>

                <Card>
                  <Card.Body>
                    <Button
                      onClick={() => {
                        setS3UploaderPopUp(true);
                      }}
                      variant="info"
                    >
                      Upload to this folder
                    </Button>
                    <Button
                      style={{ width: "max-content" }}
                      onClick={() => {
                        setSelectedFileNames(currentSelected);
                        setCurrentScreen("existingFolder");
                      }}
                      variant="primary"
                    >
                      Choose Selected Files
                    </Button>
                    <Table
                      responsive
                      className="table-nowrap table-centered mb-0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="mastercheck"
                              onChange={(e) => handleUploadAllFiles(e)}
                              checked={selectAll}
                            />
                          </th>
                          <th>ID</th>
                          <th>Preview</th>
                          <th>FileName</th>
                          <th>Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(opCreativeUploadState.s3Files || []).map(
                          (file: any, index: number) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="mastercheck"
                                    onChange={(e) =>
                                      addToSelectedFiles(file, e)
                                    }
                                    checked={
                                      currentSelectedID.includes(file.id)
                                        ? true
                                        : false
                                    }
                                  />
                                </td>
                                <td>{file.id}</td>
                                <td>
                                  <img
                                    src={`https://cloud-images.s3.eu-west-1.amazonaws.com/${opCreativeUploadState.curFolder}${file.name}`}
                                    alt={" "}
                                    height="50"
                                    width="120"
                                    onClick={() => {
                                      setImgShow(true);
                                      setImgShowURL(
                                        `https://cloud-images.s3.eu-west-1.amazonaws.com/${opCreativeUploadState.curFolder}${file.name}`
                                      );
                                    }}
                                  />
                                </td>
                                <td>{file.name}</td>
                                <td>{file.size}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <ModalImageShow
              show={imgShow}
              imgShowURL={imgShowURL}
              onHide={() => {
                setImgShow(false);
                setImgShowURL("");
              }}
            />
          </>
        )}
        {S3UploaderPopUp && (
          <>
            <div className="S3-Uploader-Popup">
              <div className="S3-Browser-Uploader">
                <Row style={{ marginBottom: "24px" }}>
                  <Col lg={6} style={{ paddingLeft: "0" }}>
                    <Card>
                      <Card.Body>
                        <FileUploader
                          onFileUpload={(files) => {
                            const namesArr: any = files.map((file) => {
                              const { path, dimensions } = file;
                              return `${path} ${dimensions}`;
                            });
                            setSelectedFileNames(namesArr);
                            setFilesToUpload(files);
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} style={{ paddingRight: "0" }}>
                    <Card style={{ height: "100%" }}>
                      <Card.Body>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          UPLOADED FILE NAMES
                        </h4>
                        {selectedFileNames.map(
                          (filename: any, index: number) => (
                            <p>{filename}</p>
                          )
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Card>
                    <Card.Body>
                      <Button
                        variant="primary"
                        style={{ margin: "0px 10px 0px 0px" }}
                        onClick={() => {
                          handleUploadToS3();
                          setS3UploaderPopUp(false);
                        }}
                        disabled={
                          selectedFileNames && selectedFileNames.length > 0
                            ? false
                            : true
                        }
                      >
                        Upload to S3
                      </Button>
                      <Button
                        onClick={() => {
                          setS3UploaderPopUp(false);
                        }}
                        variant="light"
                        style={{ margin: "0" }}
                      >
                        Cancel
                      </Button>
                    </Card.Body>
                  </Card>
                </Row>
              </div>
            </div>
          </>
        )}
        {currentScreen === "DSPsubmit" && (
          <>
            {opCreativeUploadState.loading && (
              <div className="popUpUser">
                <Spinner className="m-2" color={"primary"}></Spinner>
              </div>
            )}
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  <Row style={{ marginBottom: "10px" }}>
                    <h4
                      style={{
                        fontSize: "15px",
                        margin: "0 0 7px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      DSP CREATIVE DATA
                    </h4>
                  </Row>
                  <Row style={{ marginBottom: "20px" }}>
                    <Col lg={2}>
                      <Form.Group className="mb-3 dspFormbtn">
                        <Select
                          options={dspOptions}
                          name="dsp"
                          placeholder="Choose DSP"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeDsp}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Select
                          options={advertiserOptions}
                          name="advertiser"
                          placeholder="Choose Advertiser"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeAdv}
                        />
                      </Form.Group>
                    </Col>
                    {/*<Col lg={2}>
                      <Form.Group className="mb-3">
                        <Select
                          options={envOptions}
                          name="env"
                          placeholder="Choose Environment"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeEnv}
                        />
                      </Form.Group>
                    </Col>*/}

                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Select
                          options={OsOptions}
                          name="os"
                          placeholder="Choose OS"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeOs}
                        />
                      </Form.Group>
                    </Col>
                    {/* <Col lg={2}>
                      <Select
                        options={tagOptions}
                        name="tag"
                        placeholder="Choose Tag Type"
                        styles={customStyles}
                        className="fsz-875rem h-100"
                        onChange={changeTag}
                      />
                    </Col> */}
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          name="CreativeName"
                          type="text"
                          id="simpleinput"
                          placeholder="prefix"
                          defaultValue={dspFormik.values.CreativeName}
                          onChange={dspFormik.handleChange}
                          onBlur={dspFormik.handleBlur}
                          className="fsz-875rem"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          name="suffix"
                          type="text"
                          id="simpleinput"
                          placeholder="suffix"
                          defaultValue={dspFormik.values.suffix}
                          onChange={dspFormik.handleChange}
                          onBlur={dspFormik.handleBlur}
                          className="fsz-875rem"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: "20px" }}>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="noas">NOAS</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="noas"
                          placeholder="Choose NOAS"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeNOAS}
                          value={noasSelection == "yes" ? yesnoOptions[0] : yesnoOptions[1]}
                          isDisabled={noasDisabled}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="cookie">Cookie</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="cookie"
                          placeholder="Choose Cookie"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeCookie}
                          defaultValue={yesnoOptions[0]}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="useragent">UserAgent</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="useragent"
                          placeholder="Choose UserAgent"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeUseragent}
                          defaultValue={yesnoOptions[1]}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="timer">Timer</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="timer"
                          placeholder="Choose Timer"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeTimer}
                          defaultValue={yesnoOptions[1]}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="infinite_fifo">Infinite FIFO</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="infinite_fifo"
                          placeholder="Choose Option"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeInfiniteFifo}
                          defaultValue={dspFormik?.initialValues?.infinite_fifo == "yes" ? yesnoOptions[0] : yesnoOptions[1]}
                        />
                      </Form.Group>
                    </Col>
                    </Row>
                    <Row style={{ marginBottom: "20px" }}>
                    <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="ipV6">Detect IPv6</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="ipV6"
                          placeholder="Choose Option"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeIpV6}
                          defaultValue={dspFormik?.initialValues?.ipV6 == "yes" ? yesnoOptions[0] : yesnoOptions[1]}
                        />
                      </Form.Group>
                    </Col>
                    {/* <Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="bundle">OTF UA Analysis</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="otf"
                          placeholder="Choose OTF"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeUA}
                        />
                      </Form.Group>
                    </Col> */}
                    {/*<Col lg={2}>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="domain">Domain</Form.Label>
                        <Select
                          options={yesnoOptions}
                          name="domain"
                          placeholder="Choose Domain"
                          styles={customStyles}
                          className="fsz-875rem h-100"
                          onChange={changeDomain}
                        />
                      </Form.Group>
                    </Col> */}
                  </Row>
                  {dspFormik.values.infinite_fifo === "yes" && (
                    <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      lg={3}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      Infinite FIFO ID
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        name="infinite_fifo_id"
                        type="text"
                        id="simpleinput"
                        defaultValue={dspFormik.values.infinite_fifo_id}
                        onChange={dspFormik.handleChange}
                        onBlur={dspFormik.handleBlur}
                        className="fsz-875rem"
                        isInvalid={!!dspFormik.errors.infinite_fifo_id}
                      />
                    </Col>
                  </Form.Group>
                  )}
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      lg={3}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      Landing Page URL
                    </Form.Label>
                    <Col lg={9}>
                      <Form.Control
                        name="landingPage"
                        type="text"
                        id="simpleinput"
                        defaultValue={dspFormik.values.landingPage}
                        onChange={dspFormik.handleChange}
                        onBlur={dspFormik.handleBlur}
                        className="fsz-875rem"
                      />
                    </Col>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Row>
            <Row style={{ marginBottom: "24px" }}>
              <Card>
                <Card.Body>
                  <h4
                    style={{
                      fontSize: "15px",
                      margin: "0 0 7px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    DSP Name Preview
                  </h4>
                  <Table
                    responsive
                    className="table-nowrap table-centered mb-0"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "50%" }}>S3 FileName</th>
                        <th style={{ width: "50%" }}>DSP File Name Preview</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedFileNames.map((filename: any, index: number) => (
                        <tr key={index}>
                          <td style={{ width: "50%" }}>{filename.fname}</td>
                          <td style={{ width: "50%" }}>
                            {dspFormik.values.CreativeName}
                            {dspFormik.values.CreativeName !== "" ? "_" : ""}
                            {/* {dspFormik.values.env}_{dspFormik.values.os}_ */}
                            {dspFormik.values.os}_{calcCurrentFolder()}
                            {dspFormik.values.suffix}_{filename.width}x
                            {filename.height}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Row>
            <Row>
              <Card>
                <Card.Body>
                  <Button
                    style={{ margin: "0" }}
                    variant="primary"
                    onClick={() => {
                      dspFormik.validateForm();
                      submitToDSP();
                      // setCurrentScreen("CreateFolder");
                    }}
                    disabled={
                      dspFormik.values.dsp !== "" &&
                      dspFormik.values.adv !== 0 &&
                      // dspFormik.values.env !== "" &&
                      dspFormik.values.os !== "" &&
                      dspFormik.values.noas !== "" &&
                      dspFormik.values.cookie !== "" &&
                      dspFormik.values.useragent !== "" &&
                      dspFormik.values.timer !== "" &&
                      dspFormik.values.landingPage !== "" &&
                      dspFormik.values.ipV6 !== "" &&
                      !(dspFormik.values.infinite_fifo == "yes" && dspFormik.values.infinite_fifo_id == "")
                        ? opCreativeUploadState.loading
                          ? true
                          : false
                        : true
                    }
                  >
                    {" "}
                    Submit to DSP
                  </Button>
                </Card.Body>
              </Card>
            </Row>
          </>
        )}
        <Modal show={showValidationModal} onHide={handleClose}>
          <Modal.Header
            style={{ borderBottom: "0", paddingBottom: "5px" }}
            onHide={handleClose}
          >
            <Modal.Title
              as="h4"
              style={{ fontSize: ".9375rem", fontWeight: "700" }}
            >
              {" "}
              {opCreativeUploadState.validName
                ? "Success"
                : "Folder already exists"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ borderBottom: "0", paddingTop: "5px" }}>
            <p>
              {" "}
              {opCreativeUploadState.validName
                ? "New folder name is vertified"
                : "Please try a different folder name"}
            </p>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "0" }}>
            <Button variant="primary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {createSubFolderPopup && (
          <>
            <Modal
              show={createSubFolderPopup}
              onHide={() => {
                setCreateSubFolderPopup(false);
                setCheckFolder(false);
              }}
            >
              <Modal.Header
                style={{ borderBottom: "0" }}
                onHide={() => {
                  setCreateSubFolderPopup(false);
                  setCheckFolder(false);
                }}
                closeButton
              >
                <Modal.Title
                  as="h4"
                  style={{ fontSize: ".9375rem", fontWeight: "700" }}
                >
                  Create New Sub-Folder
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={4}
                    htmlFor="folder_name"
                    id="smallerFontSize"
                  >
                    Folder Name
                    {createSubFolderForm.errors.folder_name && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        {createSubFolderForm.errors.folder_name}
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={8}>
                    <FormControl
                      name="folder_name"
                      onChange={(e) => {
                        setCheckFolder(false);
                        setFolderName(e.target.value);
                        createSubFolderForm.handleChange(e);
                      }}
                      onBlur={createSubFolderForm.handleBlur}
                    ></FormControl>
                  </Col>
                </Form.Group>
                {!validFolder && checkFolder && (
                  <p
                    style={{
                      fontWeight: 700,
                      fontSize: "0.875rem !important",
                      color: "#ff0000",
                    }}
                  >
                    Folder name already exists. Please use a different name.
                  </p>
                )}
              </Modal.Body>
              <Modal.Footer style={{ borderTop: "0" }}>
                <Button
                  variant="light"
                  onClick={() => {
                    setCheckFolder(false);
                    setCreateSubFolderPopup(false);
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    if (
                      JSON.stringify(createSubFolderForm.errors) === "{}" &&
                      JSON.stringify(createSubFolderForm.touched) !== "{}"
                    ) {
                      handleCreateSubFolder();
                      // createSubFolderForm.handleSubmit();
                      // setCreateSubFolderPopup(false);
                    }
                  }}
                >
                  Save changes
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Col>
    </>
  );
};

export default OPCreativeUpload;
